





















import { Validator } from 'vee-validate'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Inject, Prop } from 'vue-property-decorator'

import { PluginMixin } from '@spa/mixins/plugin'

@Component
export default class SmsAuthTokenForm extends Mixins<PluginMixin>(PluginMixin) {
  @Inject()
  $validator: Validator

  @Prop({ default: '' })
  token: string

  @Prop({ required: true })
  handleTokenChanged: (val: string) => void

  @Prop({ default: true })
  showTitle: boolean

  get validation(): any {
    return {
      required: true,
      numeric: true,

      // SMS認証コードは4桁
      max: 4,
      min: 4,
    }
  }

  handleInputToken(token: string): void {
    this.handleTokenChanged(token)
  }
}
